/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeBillingPaymentDto } from '../../models/change-billing-payment-dto';
import { SubscriptionDto } from '../../models/subscription-dto';

export interface SubscribeControllerChangeBillingPayment$Params {
      body: ChangeBillingPaymentDto
}

export function subscribeControllerChangeBillingPayment(http: HttpClient, rootUrl: string, params: SubscribeControllerChangeBillingPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscribeControllerChangeBillingPayment.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

subscribeControllerChangeBillingPayment.PATH = '/api/subscribe/change-billing';
